export default {
  HOME: "home",
  HOSPITAL: "hospital",
  OTHER: "other"
}
